import { Component } from "vue";
import DateStandardizationFormatPopover from "../components/DateStandardizationFormatPopover.vue";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";
import { RuleHelpContentType } from "../models/RuleHelpContentType";


export class RuleHelpContentFactory extends HelpContentFactory<RuleHelpContentType> {

    public cdnContentPath: string = "data_cleaning";

    public async tryGetStaticHelpContentByType(type: RuleHelpContentType | string): Promise<Component | null> {
        switch (type) {
            case RuleHelpContentType.DateStandardizationFormat:
                return DateStandardizationFormatPopover;
            default:
                return null;
        }
    }

}
